import BadgesModelV2 from "../Badges/v2/BadgesModelV2";
import PointsModel from "../Points/PointsModel";
import TiersModel from "../Tiers/TiersModel";

export default class RewardsModelV2 {
  public points: PointsModel = null;
  public tiers: TiersModel[] = null;
  public badges: BadgesModelV2 = null;
}
